import React from "react";
import toSlug from "../../util/Slug";
import Key from "../../util/Key";
import switchValidation from "../../validation/swtichValidation";

export const TextArea = ({
    input,
    register,
    errors,
    where = "preview",
    color = "212529",
    background = "#fff",
    // border = "1px solid #ced4da",
    inline,
    showlabel,
}) => {
    const slugData = toSlug(input.label);
    const labelStyles = {
        color: "#" + color,
    };
    const inputStyle = {
        backgroundColor: background,
        // border: border,
        color: "#" + color,
    };
    const colums = () => {
        if (where == "form") {
            if (inline != false) {
                return inline;
            } else {
                if (input.size == "0") {
                    return "col-sm-6 col-12 mb-3";
                } else {
                    return "col-12 mb-3";
                }
            }
        } else {
            return "";
        }
    };

    return (
        <div className={colums()} key={Key()}>
            <div className="contiene-input">
                {showlabel == true && (
                    <label style={labelStyles} className="form-label">
                        {input.label}
                    </label>
                )}

                <textarea
                    style={inputStyle}
                    className={`input-border form-control orm-control-material
        ${errors[slugData] ? "is-invalid" : ""}`}
                    placeholder={input.placeholder}
                    name={input.label && input.label}
                    {...register(slugData, {
                        required:
                            input.required === "1"
                                ? input.error_message
                                : false,
                        validate: switchValidation(
                            input.required === "1"
                                ? input.input.validation_type
                                : false
                        ),
                    })}
                />
                {errors[slugData] && (
                    <div className="invalid-feedback">
                        {errors[slugData].message}
                    </div>
                )}
            </div>
        </div>
    );
};
export default TextArea;
